import { FC, SVGProps } from 'react'

export const Unlink: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.64645 1.64645C1.84171 1.45118 2.15829 1.45118 2.35355 1.64645L14.3536 13.6464C14.5488 13.8417 14.5488 14.1583 14.3536 14.3536C14.1583 14.5488 13.8417 14.5488 13.6464 14.3536L7.79289 8.5H5.33333C5.05719 8.5 4.83333 8.27614 4.83333 8C4.83333 7.72386 5.05719 7.5 5.33333 7.5H6.79289L4.53006 5.23716C3.38806 5.51998 2.5 6.62911 2.5 8C2.5 9.59786 3.70097 10.8333 5.11111 10.8333H6.66667C6.94281 10.8333 7.16667 11.0572 7.16667 11.3333C7.16667 11.6095 6.94281 11.8333 6.66667 11.8333H5.11111C3.08482 11.8333 1.5 10.084 1.5 8C1.5 6.41468 2.41388 5.02718 3.74344 4.45055L1.64645 2.35355C1.45118 2.15829 1.45118 1.84171 1.64645 1.64645ZM8.83333 4.66667C8.83333 4.39052 9.05719 4.16667 9.33333 4.16667H10.8889C12.9152 4.16667 14.5 5.91596 14.5 8C14.5 8.72571 14.3097 9.40716 13.9768 9.98861C13.8396 10.2283 13.5342 10.3113 13.2945 10.1742C13.0548 10.037 12.9718 9.73149 13.109 9.49183C13.356 9.06021 13.5 8.54981 13.5 8C13.5 6.40214 12.299 5.16667 10.8889 5.16667H9.33333C9.05719 5.16667 8.83333 4.94281 8.83333 4.66667Z"
      fill="#1B1B1B"
    />
  </svg>
)
